import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import MenuList from "@mui/material/MenuList";
import Typography from "@mui/material/Typography";
import CustomMenuItem from "../unit/CustomMenuItem";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";

export default function AdminsAside() {
  return (
    <Card
      sx={{
        display: {
          xs: "none",
          md: "block",
        },
        order: -1,
        flex: "0 0 15em",
        mr: 2,
        mt: 2,
        alignSelf: "flex-start",
        width: "238px",
      }}
    >
      <CardContent sx={{ pt: 1 }}>
        <MenuList component="div">
          <HmSubHeaderTitle title="Admins" sx={{ mb: 2 }} />
          <CustomMenuItemLink
            to="/admins"
            state={{ _scrollToTop: true }}
            primaryText="Admins"
            selected={true}
          />
          <CustomMenuItemLink
            to="/admins"
            state={{ _scrollToTop: true }}
            primaryText="Admins"
          />
          <CustomMenuItem selected={true}>
            <Typography variant="inherit" noWrap>
              A very long text t
            </Typography>
          </CustomMenuItem>
        </MenuList>
      </CardContent>
    </Card>
  );
}
